import { useMutation } from '@tanstack/react-query'
import { apiInstance } from 'services/api'
import { useMasquaradeToken } from 'services/masquarade/masquarade.hooks'
import { useAccessToken } from 'services/token/token.hooks'

export const useHelpdeskTicketsMessagesCreate = () => {
  const { accessToken } = useAccessToken()
  const { masquaradeToken } = useMasquaradeToken()

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({
      message,
      attachment,
      ticketId
    }: {
      message: string
      attachment: File | null
      ticketId: number
    }) => {
      const form = new FormData()

      form.append('message', message)
      if (!!attachment) {
        form.append('attachment', attachment)
      }
      return apiInstance({
        url: `/helpdesk/tickets/${ticketId}/messages/`,
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
          'mask-authorization': !!masquaradeToken ? `Token ${masquaradeToken}` : undefined,
          'Content-Type': 'multipart/form-data'
        },
        data: form,
        transformRequest: (data) => {
          return data
        }
      })
    }
  })

  return { createMessage: mutateAsync, ...rest }
}
